var map = {
	"./1.jpg": "3qjg",
	"./11.jpg": "IyZG",
	"./2.jpg": "cAxn",
	"./4.jpg": "4ypd",
	"./5.jpg": "8ZNX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BPoR";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/eventBanner ^\.\/.*\.jpg$
// module id = BPoR
// module chunks = 9